export const NewConstruction = (props) => {
  const { size = 24, onClick, verticalAlign, marginLeft, marginRight, top, color, className = ' ' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg xmlns='http://www.w3.org/2000/svg' style={{ verticalAlign }} width={size} height={size} fill='none' viewBox='0 0 24 24'>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M3.497 19.003h.7c1.175 0 2.324.349 3.301 1v0c.978.652 2.127 1 3.302 1.001h2.4a5.956 5.956 0 003.302-1v0c.978-.652 2.127-1 3.302-1h.7a1.5 1.5 0 001.5-1.501v0a1.5 1.5 0 00-1.5-1.501H3.497a1.5 1.5 0 00-1.5 1.5v0a1.5 1.5 0 001.5 1.501z'
          clipRule='evenodd'
        ></path>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M6.998 5.797v2.201a1.5 1.5 0 001.5 1.5v0A1.5 1.5 0 0010 7.999v-2A2 2 0 0112 3.996v0a2 2 0 012.001 2v2.001a1.5 1.5 0 001.5 1.5v0a1.5 1.5 0 001.501-1.5v-2.2'
        ></path>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M13.732 4.997h.269A6.002 6.002 0 0120.003 11v5.002M10.268 4.997H10A6.003 6.003 0 003.997 11v5.002'
        ></path>
      </svg>
    </span>
  );
};
